import { Button, SelectControl, TextControl } from '@wordpress/components'
import update from 'immutability-helper'
import CompanyOptions from '../Components/GeneralOptions/CompanyOptions'
import StateOptions from '../Components/ProfileOptions/StateOptions'
import React from 'react'
import { filterNewClassmates } from './Functions'

const SearchForm = ({ state, setState }) => {
  return (
    <div className='classmates-searchbox'>
      <div className='name'>
        <label htmlFor='name'>Name</label>
        <TextControl
          value={state.name}
          onChange={(value) => {
            filterNewClassmates(
              update(state, { name: { $set: value } }),
              setState
            )
          }}
        />
      </div>
      <div className='company'>
        <label htmlFor='company'>Company</label>
        <SelectControl
          value={state.company}
          onChange={(value) => {
            filterNewClassmates(
              update(state, { company: { $set: value } }),
              setState
            )
          }}
          options={CompanyOptions}
        />
      </div>
      <div className='city'>
        <label htmlFor='city'>City</label>
        <TextControl
          value={state.city}
          onChange={(value) => {
            filterNewClassmates(
              update(state, { city: { $set: value } }),
              setState
            )
          }}
        />
      </div>
      <div className='state'>
        <label htmlFor='state'>State</label>
        <SelectControl
          value={state.state}
          onChange={(value) => {
            filterNewClassmates(
              update(state, { state: { $set: value } }),
              setState
            )
          }}
          options={StateOptions}
        />
      </div>
      <div className='search'>
        <label>&nbsp;</label>
        <Button className='btn btn-success'>Search</Button>
      </div>
    </div>
  )
}

export {
  SearchForm
}
